import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const guestGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const token = JSON.parse(localStorage.getItem("loginObject") || "{}").token;

  if (token) {
    // ✅ Already logged in → redirect to dashboard
    // return router.navigate(['/main/dashboard']);
     window.location.href = '/main/dashboard';
   
  }

  return true; // ✅ allow access to login page
};
